export var MulticastGroupCommand;
(function (MulticastGroupCommand) {
    MulticastGroupCommand["setValue"] = "multicast_group.set_value";
    MulticastGroupCommand["getEndpointCount"] = "multicast_group.get_endpoint_count";
    MulticastGroupCommand["supportsCC"] = "multicast_group.supports_cc";
    MulticastGroupCommand["getCCVersion"] = "multicast_group.get_cc_version";
    MulticastGroupCommand["invokeCCAPI"] = "multicast_group.invoke_cc_api";
    MulticastGroupCommand["supportsCCAPI"] = "multicast_group.supports_cc_api";
    MulticastGroupCommand["getDefinedValueIDs"] = "multicast_group.get_defined_value_ids";
})(MulticastGroupCommand || (MulticastGroupCommand = {}));
